<template>
  <v-app id="app">
    <template v-if="$store.state.merchant.id">
      <v-main v-if="template === 1">
        <div :class="{'nav-spacing': $vuetify.breakpoint.mdAndUp}">
          <DefaultDesktopNav v-if="$vuetify.breakpoint.mdAndUp"/>
          <router-view/>
        </div>
      </v-main>

      <v-main v-else-if="template === 2" class="boxed">
        <div :class="{'nav-spacing': $vuetify.breakpoint.mdAndUp}">
          <BoxedDesktopNav v-if="$vuetify.breakpoint.mdAndUp"/>
          <router-view/>
        </div>
      </v-main>

      <v-main v-else-if="template === 3" class="bannerless">
        <div :class="{'nav-spacing': $vuetify.breakpoint.mdAndUp}">
          <BannerLessDesktopNav v-if="$vuetify.breakpoint.mdAndUp"/>
          <router-view/>
        </div>
      </v-main>

      <v-main v-else-if="template === 4" class="vinova">
        <div :class="{'nav-spacing': $vuetify.breakpoint.mdAndUp}">
          <DefaultDesktopNav v-if="$vuetify.breakpoint.mdAndUp"/>
          <router-view/>
        </div>
      </v-main>

      <v-main v-else-if="template === 5" class="venedor">
        <div :class="{'nav-spacing': $vuetify.breakpoint.mdAndUp}">
          <VenedorDesktopNav v-if="$vuetify.breakpoint.mdAndUp"/>
          <router-view/>
        </div>
      </v-main>
    </template>


    <v-main v-else class="venedor">
      <router-view/>
    </v-main>

    <QuickPreview/>

    <CartMobile v-if="$vuetify.breakpoint.mdAndDown"/>
    <CartDesktop v-else/>
  </v-app>
</template>

<script>
import DefaultDesktopNav from "./components/templates/default/DefaultDesktopNav";
import BoxedDesktopNav from "./components/templates/boxed/BoxedDesktopNav";
import BannerLessDesktopNav from "./components/templates/bannerless/BannerLessDesktopNav";
import CartDesktop from "./components/cart/CartDesktop";
import CartMobile from "./components/cart/CartMobile";
import VenedorDesktopNav from "./components/templates/venedor/VenedorDesktopNav";
import QuickPreview from "@/components/catalogue/QuickPreview";

export default {
  name: 'App',
  components: {
    QuickPreview,
    VenedorDesktopNav,
    BannerLessDesktopNav,
    CartMobile,
    CartDesktop,
    BoxedDesktopNav,
    DefaultDesktopNav
  },
  metaInfo() {
    if (this.$store.state.merchant?.name) {
      return {
        title: 'Store',
        titleTemplate: `%s • ${ this.$store.state.merchant.name }`
      }
    } else {
      return null
    }
  },
  created() {
    this.setVH();
    window.addEventListener('resize', () => this.setVH());
  },
  methods: {
    setVH() {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${ vh }px`);
    }
  },
  computed: {
    theme_color() {
      return this.$store.state.merchant.theme_color;
    },
    template() {
      return this.$store.getters['merchant/template'];
    }
  },
  watch: {
    theme_color(theme_color) {
      if (theme_color && theme_color.match(/^#(?:[0-9a-f]{3}){1,2}$/i)) {
        this.$vuetify.theme.themes.light.primary = theme_color;
        this.$vuetify.theme.themes.dark.primary = theme_color;
      }
    }
  }
}
</script>

<style lang="scss">
@import "assets/global";

.v-main {
  @media (max-width: 960px) {
    background: rgb(236, 239, 241);
  }
}

.nav-spacing {
  padding-top: 115px;
  overflow-y: initial;
  transition: all .15s linear;
}

.nav-spacing-mobile {
  padding-top: 90px;
  overflow-y: initial;
  transition: all .15s linear;
  min-height: calc((var(--vh, 1vh) * 100));
}

.bottom-nav-spacing {
  padding-bottom: 70px !important;
}

.boxed {
  .nav-spacing {
    padding-top: 90px;
  }
}

.venedor {
  .nav-spacing {
    padding-top: 120px;
  }
}
</style>
